<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3 mobile-hide"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Greeting — Login: nur H1, kein Eyebrow / kein Lede (Returning User) -->
      <div class="desk-greet">
        <h1>
          {{ "LOGIN_GREET_LINE_1" | translate }}
          <span class="grad">{{ "LOGIN_GREET_BRAND" | translate }}</span>
        </h1>
        <p class="lede mobile-hide" *ngIf="isTerminalMode">
          {{ "TERMINAL_LOGIN_DESC" | translate }}
        </p>
      </div>

      <!-- C-08: Sitzungsablauf hatte weder Meldung noch Rueckweg - man landete still hier
           und nach dem Anmelden auf dem Dashboard. Die Ansage steht bewusst als ruhiger
           Hinweis IM Formular und nicht als roter Fehler: Es ist kein Fehler des Nutzers.
           role="status" statt "alert", damit Vorlesehilfen den Text ankuendigen, ohne die
           Eingabe zu unterbrechen. Sichtbar nur mit ?reason=expired. -->
      <p *ngIf="sessionExpired" class="auth-session-expired" role="status">
        <i class="fa-light fa-clock-rotate-left" aria-hidden="true"></i>
        <span>{{ "SESSION_EXPIRED_HINT" | translate }}</span>
      </p>

      <!-- BIOMETRIC: Quick Login Button wenn Biometrie aktiviert (Banking-App Style) -->
      <div
        *ngIf="showBiometricButton && !isLoading"
        class="biometric-quick-login"
      >
        <!-- TODO xds-migrate: zusammengesetzter Banking-App-Button (rundes Icon oben,
             2-zeiliger Content darunter) - passt nicht in das iconLeft/ng-content-Slot-Modell
             von xds-button -->
        <button
          type="button"
          class="btn-biometric-large"
          (click)="loginWithBiometric()"
        >
          <!-- Großes Icon zentriert oben -->
          <div class="biometric-icon-wrapper">
            <i
              class="fa-light"
              [class.fa-fingerprint]="
                biometricType === 1 || biometricType === 3
              "
              [class.fa-face-viewfinder]="
                biometricType === 2 || biometricType === 4
              "
              [class.fa-eye]="biometricType === 5"
              [class.fa-shield-keyhole]="
                !biometricType || biometricType === 0 || biometricType === 6
              "
            >
            </i>
          </div>
          <!-- Text und Email vertikal gestapelt -->
          <div class="biometric-content">
            <span class="biometric-label">{{ "BIOMETRIC_LOGIN_WITH" | translate: { biometricType: biometricTypeName } }}</span>
            <span class="biometric-email">{{ formModel.EmailOrUserName }}</span>
          </div>
        </button>

        <xds-button
          variant="ghost"
          size="sm"
          (clicked)="disableBiometric()"
        >
          {{ "BIOMETRIC_USE_OTHER_ACCOUNT" | translate }}
        </xds-button>

        <div class="divider">
          <span>{{ "BIOMETRIC_OR_PASSWORD" | translate }}</span>
        </div>
      </div>

      <!-- Login Form - Hide in Terminal Mode (use pairing instead) -->
      <form #form="ngForm" (submit)="onSubmit(form)" class="auth-form xds-form-stack" *ngIf="!isTerminalMode">
        <!-- Email/Username Field -->
        <xds-form-field
          [labelKey]="isTerminalMode ? 'TERMINAL_USERNAME' : 'EMAIL'"
          [invalid]="EmailOrUserName.invalid && (EmailOrUserName.touched || formSubmitted)"
        >
          <xds-input
            appAutofill
            [type]="isTerminalMode ? 'text' : 'email'"
            [invalid]="EmailOrUserName.invalid && (EmailOrUserName.touched || formSubmitted)"
            [placeholderKey]="isTerminalMode ? 'terminal01' : 'name@example.com'"
            #EmailOrUserName="ngModel"
            name="EmailOrUserName"
            [(ngModel)]="formModel.EmailOrUserName"
            required
            autocomplete="email"
            [iconLeft]="isTerminalMode ? 'fa-light fa-terminal' : 'fa-light fa-envelope'"
            [testId]="isTerminalMode ? 'login-terminal-username' : 'login-email'"
          ></xds-input>
        </xds-form-field>

        <!-- Local Email Hint -->
        <xds-banner *ngIf="showLocalEmailHint" variant="warning" messageKey="LOCAL_EMAIL_HINT"></xds-banner>

        <!-- Password Field -->
        <xds-form-field
          labelKey="PASSWORD"
          [invalid]="Password.invalid && (Password.touched || formSubmitted)"
        >
          <xds-input
            appAutofill
            [type]="showPassword ? 'text' : 'password'"
            [invalid]="Password.invalid && (Password.touched || formSubmitted)"
            placeholderKey="ENTER_PASSWORD"
            #Password="ngModel"
            name="Password"
            [(ngModel)]="formModel.Password"
            required
            autocomplete="current-password"
            testId="login-password"
          >
            <ng-container ngProjectAs="[xdsInputTrailing]">
              <xds-icon-button
                [icon]="showPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                [ariaLabel]="(showPassword ? 'HIDE_PASSWORD' : 'SHOW_PASSWORD') | translate"
                (clicked)="toggleShowPassword()"
              ></xds-icon-button>
            </ng-container>
          </xds-input>
        </xds-form-field>

        <!-- Remember Me & Forgot Password & Enable Biometric -->
        <div class="form-options">
          <div class="options-left">
            <xds-checkbox name="rememberMe" [(ngModel)]="formModel.RememberMe" labelKey="REMEMBER_ME" testId="login-remember-me"></xds-checkbox>

            <!-- BIOMETRIC: Enable Biometric Checkbox -->
            <xds-checkbox
              *ngIf="biometricAvailable && !biometricEnabled"
              name="enableBiometric"
              [(ngModel)]="enableBiometric"
            >
              <span class="checkbox-label">
                <i class="fa-light fa-fingerprint"></i>
                {{ "BIOMETRIC_ACTIVATE" | translate }}
              </span>
            </xds-checkbox>
          </div>

          <a class="link-text" [routerLink]="['/forgotpassword']" data-testid="login-forgot-password">
            {{ "FORGOT_PASSWORD" | translate }}
          </a>
        </div>

        <!-- BIOMETRIC: Info wenn Biometrie aktiviert wird -->
        <xds-banner *ngIf="enableBiometric && biometricAvailable" variant="info" icon="fa-light fa-shield-check">
          {{ "BIOMETRIC_SAVE_INFO" | translate: { biometricType: biometricTypeName } }}
        </xds-banner>

        <!-- Error Message -->
        <xds-banner *ngIf="errorStatus.showError" variant="danger">{{ errorStatus.errorMessage }}</xds-banner>

        <!-- FE-12 P2: Kontosperre (401, ErrorType UserLockedOut) inline statt Toast — ein Toast
             kann den Weg „Passwort zurücksetzen“ nicht anbieten, und der Reset hebt die Sperre
             sofort auf. Die eingegebene Adresse wird auf /forgotpassword vorbelegt. -->
        <div *ngIf="lockedOut" class="auth-lockout" data-testid="login-locked-out">
          <xds-banner variant="danger">{{ "LOGIN_ERROR_LOCKED_OUT_RESET_LINK" | translate }}</xds-banner>
          <a
            class="link-text"
            [routerLink]="['/forgotpassword']"
            [queryParams]="lockedOutResetQueryParams"
            data-testid="login-locked-out-reset"
          >
            {{ "RESET_PASSWORD" | translate }}
          </a>
        </div>

        <!-- Submit Button -->
        <xds-button
          variant="primary"
          [block]="true"
          type="submit"
          iconLeft="fa-light fa-arrow-right-to-bracket mobile-hide"
          [loading]="isLoading"
          [disabled]="isLoading"
          data-testid="login-submit-button"
        >
          {{ "LOG_IN" | translate }}
        </xds-button>

        <!-- BIOMETRIC: Alternative Biometric Login wenn aktiviert aber nicht im Quick-Mode -->
        <xds-button
          *ngIf="biometricEnabled && !showBiometricButton"
          variant="secondary"
          [block]="true"
          iconLeft="fa-light fa-fingerprint"
          (clicked)="loginWithBiometric()"
          style="margin-top: 0.5rem"
        >
          {{ "BIOMETRIC_LOGIN_WITH" | translate: { biometricType: biometricTypeName } }}
        </xds-button>

        <!-- Alternative Actions - Kompakter auf Mobile -->
        <div class="form-footer" *ngIf="!isTerminalMode">
          <div class="divider">
            <span>{{ "OR" | translate }}</span>
          </div>

          <div class="alternative-actions">
            <!-- iOS: Kein Registrierungslink (App Store Guideline 3.1.1) -->
            <ng-container *ngIf="!isIos; else iosAccountHint">
              <a class="link-text" [routerLink]="['/registration']" data-testid="login-create-account">
                {{ "CREATE_ACCOUNT" | translate }}
              </a>
            </ng-container>
            <ng-template #iosAccountHint>
              <span class="ios-hint-text">
                <i class="fa-light fa-circle-info"></i>
                {{ "CREATE_ACCOUNT_IOS_HINT" | translate }}
              </span>
            </ng-template>
          </div>
        </div>

      </form>

      <!-- PAIRING CODE FORM - Always show in Terminal Mode -->
      <div class="pairing-form-container" *ngIf="isTerminalMode">
        <div class="pairing-form-header">
          <i class="fa-light fa-qrcode"></i>
          <h3>{{ "TERMINAL.PAIRING.TITLE" | translate }}</h3>
        </div>

        <p class="pairing-form-description">
          {{ "TERMINAL.PAIRING.INSTRUCTIONS" | translate }}
        </p>

        <form (submit)="submitPairingCode()" class="pairing-form xds-form-stack">
          <!-- QR Code Scanner Button (nur wenn unterstützt) -->
          <xds-button
            *ngIf="isScannerSupported"
            variant="primary"
            [block]="true"
            iconLeft="fa-light fa-camera"
            [loading]="isScanning"
            [disabled]="isLoading || isScanning"
            (clicked)="scanQrCode()"
            data-testid="qr-scanner-button"
          >
            {{
              (isScanning
                ? "TERMINAL.PAIRING.SCANNING"
                : "TERMINAL.PAIRING.SCAN_QR"
              ) | translate
            }}
          </xds-button>

          <!-- Divider mit "ODER" -->
          <div class="divider" *ngIf="isScannerSupported">
            <span>{{ "TERMINAL.PAIRING.OR" | translate }}</span>
          </div>

          <!-- Pairing Code Input -->
          <xds-form-field
            icon="fa-light fa-key"
            [labelKey]="
              isScannerSupported
                ? 'TERMINAL.PAIRING.CODE_LABEL_MANUAL'
                : 'TERMINAL.PAIRING.CODE_LABEL_LENGTH'
            "
          >
            <xds-input
              type="text"
              class="pairing-code-input"
              placeholder="ABCD1234"
              [(ngModel)]="pairingFormModel.code"
              (input)="onPairingCodeInput($event)"
              name="pairingCode"
              iconLeft="fa-light fa-hashtag"
              required
              data-testid="pairing-code-input"
            ></xds-input>
          </xds-form-field>

          <!-- HELP_2 statt eines neuen Textes: Er sagt dasselbe genauer — die
               verwechselbaren Zeichen 0, O, I und 1 kommen im Code nicht vor. -->
          <xds-banner
            variant="info"
            messageKey="TERMINAL.PAIRING.HELP_2"
          ></xds-banner>

          <!-- Submit Button -->
          <xds-button
            variant="primary"
            [block]="true"
            type="submit"
            iconLeft="fa-light fa-link mobile-hide"
            [loading]="isLoading"
            [disabled]="pairingFormModel.code.length !== 8 || isLoading"
            data-testid="pairing-submit-button"
          >
            {{ "TERMINAL.PAIRING.PAIR_BUTTON" | translate }}
          </xds-button>

          <!-- Info Box -->
          <div class="pairing-info-box">
            <i class="fa-light fa-lightbulb"></i>
            <div>
              <strong>{{ "TERMINAL.PAIRING.TIP_LABEL" | translate }}</strong>
              {{ "TERMINAL.PAIRING.TIP_TEXT" | translate }}
            </div>
          </div>
        </form>
      </div>

      <!-- Login Mode Toggle - Kompakter -->
      <div class="mode-toggle">
        <xds-button
          variant="ghost"
          size="sm"
          [iconLeft]="isTerminalMode ? 'fa-light fa-user' : 'fa-light fa-terminal'"
          (clicked)="toggleLoginMode()"
          [attr.data-testid]="isTerminalMode ? 'switch-to-employee-login' : 'switch-to-terminal-login'"
        >
          <span *ngIf="isTerminalMode">
            {{ "SWITCH_TO_EMPLOYEE_LOGIN" | translate }}
          </span>
          <span *ngIf="!isTerminalMode">
            {{ "SWITCH_TO_TERMINAL_LOGIN" | translate }}
          </span>
        </xds-button>

        <!-- BIOMETRIC: Settings wenn Biometrie aktiviert -->
        <xds-button
          *ngIf="biometricEnabled"
          variant="ghost"
          size="sm"
          iconLeft="fa-light fa-fingerprint-slash"
          (clicked)="disableBiometric()"
          style="margin-left: 0.5rem"
        >
          {{ "BIOMETRIC_DEACTIVATE" | translate }}
        </xds-button>
      </div>
    </div>
    <app-auth-legal-footer></app-auth-legal-footer>
  </div>
</div>
